<template>
  <AppHeader :class="{ 'gray-header': isMainPage }" />

  <div class="app-container" :class="{ 'gray-page': isMainPage }">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>

  <AppMenu />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router'; // 1. useRoute 임포트

import AppHeader from '@/components/domains/mobile/common/AppHeader.vue';
import AppMenu from '@/components/domains/mobile/common/AppMenu.vue';

const route = useRoute(); // 2. 라우트 객체 가져오기

// 3. 현재 라우트 이름이 'MainView'인지 확인하는 computed 변수
const isMainPage = computed(() => route.name === 'app-main-view');
</script>

<style scoped lang="scss">
.app-header {
  &.gray-header {
    background: $gray10;
  }
}
.app-container {
  &.gray-page {
    background: $gray10;
  }
}
</style>
